var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2373 6.2627L5.76243 8.73757",
    stroke: "#6D7784",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02765 4.58319L6.99988 3.61096C8.07377 2.53707 9.8149 2.53707 10.8888 3.61096V3.61096C11.9627 4.68485 11.9627 6.42598 10.8888 7.49987L9.91656 8.4721",
    stroke: "#6D7784",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97235 10.4168L7.00012 11.389C5.92623 12.4629 4.1851 12.4629 3.11121 11.389V11.389C2.03731 10.3151 2.03731 8.57402 3.11121 7.50013L4.08344 6.5279",
    stroke: "#6D7784",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.a4cd0a0c21c0c72ac56487b033d8cbd3.svg";
export { ForwardRef as ReactComponent };